import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { config } from "../Environment";
import useRetryFetch from "../hooks/useRetryFetch";
import useProcess from "../hooks/useProcess";
import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import LoggerContext from "../context/LoggerProvider";
import useAuth from "../hooks/useAuth";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import loadingImage from "../images/loading.gif";

function EntryActivity() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const retryFetch = useRetryFetch();
  const { startProcess, resumeProcess } = useProcess();
  const { auth } = useAuth();
  const { Logger } = useContext(LoggerContext);
  const { t } = useTranslation();
  const [authenticated, setAuthenticated] = useState(false);

  if (auth?.email) {
    setAuthenticated(true);
  }

  async function continueProcess(processId) {
    await resumeProcess({
      processId,
    });
  }

  async function runPrescription(prescriptionId) {
    await startProcess({
      prescriptionId,
    });
  }

  useEffect(() => {
    const email = auth?.email ?? null;
    if (email) {
      // const searchParams = new URLSearchParams(location.search);
      const workflowId = searchParams.get("wid");
      const processId = searchParams.get("pid");

      setTimeout(() => {
        if (processId) {
          console.log(`EntryActivity.jsx continuing process ${processId}`);
          continueProcess(processId);
        } else if (workflowId) {
          console.log(`EntryActivity.jsx starting workflow ${workflowId}`);
          runPrescription(workflowId);
        } else {
          navigate("/portal");
        }
      }, 1000);
    }
  }, []);

  function renderAuthenticated() {
    return (
        <div className="loadingcenter">
          <img src={loadingImage} alt={t("loading")} title={t("loading")} width="32" height="32" />
        </div>
    );
  }

  function renderNotAuthenticated() {
    return (
      <Card className="center">
        <CardContent side="bottom">
          <CardHeader>
            <CardTitle>You are signed out</CardTitle>
          </CardHeader>
<p style={{"margin":"5px"}}>Thank you for using ClaryNext.</p>
<p style={{"margin":"5px"}}><strong>Where to go from here?</strong></p>
<p style={{"margin":"5px"}}>Sign in to return to the activity.</p>
<p style={{"margin":"5px"}}>Visit our website:</p>
<p style={{"margin":"5px"}}><a href="https://clarynext.com" style={{"color":"blue","textDecoration":"underline"}}>ClaryNext.com</a></p>
        </CardContent>
      </Card>
    );
  }

  if (authenticated) {
    return renderAuthenticated();
  } else {
    return renderNotAuthenticated();
  }

}

export default EntryActivity;
